/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Export_Error_Plans_MinInputs */



/**
* | output |
* | --- |
* | "Number of plans must be greater than 0" |
*
* @param {Intervention_Plan_Export_Error_Plans_MinInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_export_error_plans_min = /** @type {((inputs?: Intervention_Plan_Export_Error_Plans_MinInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Export_Error_Plans_MinInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of plans must be greater than 0")
	return /** @type {LocalizedString} */ ("Le nombre de plans doit être supérieur à 0")
});